import { Link } from 'react-router-dom'
import styles from './AuthPage.module.css'
import SignInModal, { showSignInModal } from "../components/auth/SignInModal";
import SignUpModal, { showSignUpModal } from "../components/auth/SignUpModal";
import ChangePasswordModal, { showChangePasswordModal } from "../components/auth/ChangePasswordModal";
import { FaKey, FaSignInAlt, FaUserPlus, FaSignOutAlt } from 'react-icons/fa';
import { authClient } from '../lib/auth-client'

export function AuthPage() {

  const { data: session, isPending } = authClient.useSession();  // Better Auth provides a useSession hook to easily access session data on the client side.

  if (isPending) return <div>Carregando...</div>;

  // Signout
  const handleSignOut = async () => {
    await authClient.signOut({
      // You can pass fetchOptions to redirect onSuccess
      fetchOptions: {
        onSuccess: () => {
          //router.push("/login"); // redirect to login page
        },
      },
    });
  };

  return (
    <div className={`${styles.page} ${styles.pageMinimal}`}>
      <header className={`${styles.header}`}>
        <div className={styles.headerTitleRow}>
          <h1>Autenticação</h1>
          <Link className={styles.backLink} to="/dashboard">
            Dashboard
          </Link>
        </div>
        <p className={styles.subtitle}>
          Teste do fluxo de autenticação Better Auth.
        </p>
      </header>

      <main>

        {session?.user ? (
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-md">
              <p className="text-green-800 font-semibold">Logado como:</p>
              <p className="text-green-700">{session.user.email}</p>
              <p className="text-green-600 text-sm">{session.user.name}</p>
            </div>
          </div>
        ):(
          <div>Sem usuário logado.</div>
        )}
        
        <div className="flex gap-3">
          <button
            type="button"
            onClick={showSignInModal}
            className={styles.btn}
            disabled={!!session?.user}
          >
            SignIn <FaSignInAlt />
          </button>

          <button
            type="button"
            onClick={showSignUpModal}
            className={styles.btn}
            disabled={!!session?.user}
          >
            SignUp <FaUserPlus />
          </button>

          <button
            type="button"
            onClick={showChangePasswordModal}
            className={styles.btn}
            disabled={!session?.user}
          >
            Alterar senha <FaKey />
          </button>

          <button
            type="button"
            onClick={handleSignOut}
            className={styles.btn}
            disabled={!session?.user}
          >
            Sair <FaSignOutAlt />
          </button>

        </div>

        <SignInModal />
        <SignUpModal />
        <ChangePasswordModal />
      </main>

    </div>
  )
}
